import { useEffect, useState } from "react"
import { ProjectProps } from "../../interfaces/project_types"
import { getActiveProjects } from "../../api/projects"
import { RouteButton } from "../Buttons"
import { Header } from "../misc"
import { ClientSection } from "./utils/ClientSections";
import { PrintClientSection } from "./utils/PrintClientSection";
import { SearchBar } from "./UI/SearchBar"
import { useSearchBar } from "./hooks/useSearchBar"
import { Toaster } from "sonner";

/**
 *  ### [Route for ('/project_status_report/:id')]
 * 
 * This component shows the status of a project based on the project id.
 * 
 * The layout is grouped by clients.
 */
export function ProjectStatusReport() {
    /**
     * TODO:
     * - Make the page printable
     */
    const [project, setProject] = useState<ProjectProps[]>()

    const {
        searchTerm,
        filteredProjects,
        filteredClients,
        handleSearchChange,
        handleClearSearch
    } = useSearchBar(project)

    useEffect(() => {
        const get_data = async () => {
            const response = await getActiveProjects()

            if (!response) {
                throw new Error("Error fetching project list")
            }

            setProject(response.data)
        }
        get_data()
    }, [])

    return(
        <>
            <Header />

            <h1 className="px-2 mb-5">Project Status Report</h1>

            <div className="print:hidden">
                <SearchBar 
                    searchTerm={searchTerm}
                    onSearchChange={handleSearchChange}
                    onClearSearch={handleClearSearch}
                />
            </div>

            {filteredProjects && filteredProjects.length === 0 && searchTerm && (
                <h1 className="flex justify-center py-2">No projects found matching "{searchTerm}"</h1>
            )}

            {filteredProjects && filteredProjects.length === 0 && !searchTerm && (
                <h1 className="flex justify-center py-2">No projects found</h1>
            )}

            {/* Screen version - interactive components */}
            <div className="print:hidden">
                {filteredClients && filteredClients.map((client, index) => 
                    client != "" && <ClientSection client={client} projects={filteredProjects} index={index} key={index} />
                )}
            
                {/* The projects without a client */}
                {filteredClients && filteredClients.map((client, index) => 
                    client === "" && <ClientSection client={client} projects={filteredProjects} index={index} key={index} />
                )}
            </div>

            {/* Print version - optimized components */}
            <div className="hidden print:block">
                {filteredClients && filteredClients.map((client, index) => 
                    client != "" && <PrintClientSection client={client} projects={filteredProjects} index={index} key={`print-${index}`} />
                )}
            
                {/* The projects without a client */}
                {filteredClients && filteredClients.map((client, index) => 
                    client === "" && <PrintClientSection client={client} projects={filteredProjects} index={index} key={`print-empty-${index}`} />
                )}
            </div>

            <div className="flex justify-center print:hidden">
                <RouteButton route="/main_menu" text="Back to Projects" />
            </div>

            <Toaster richColors />
        </>
    )
}